import React from 'react';

export const TableData = ({ children }: { children: React.ReactNode }) => {
  return <td className='w-20 px-4 py-2 text-black'>{children}</td>;
};
